<template lang="pug">
  .list.draft-curriculum-list.media-list
    ul
      draft-curriculum-list-item(
        v-for="curriculum in curriculums"
        :key="curriculum.id"
        :curriculum="curriculum"
        @click="$emit('click', curriculum.id)")
</template>

<style lang="scss" scoped>
.draft-curriculum-list {
  margin: 0;
}
</style>

<script>
import DraftCurriculumListItem from '@/components/molecules/DraftCurriculumListItem'

export default {
  components: {
    DraftCurriculumListItem,
  },
  props: {
    curriculums: {
      type: Array,
      required: true,
    },
  },
}
</script>
